import { Component, OnInit, Input } from '@angular/core';

import { IDrawerComponentLiaison } from '../../interfaces/idrawer-component-liaison';

// Note:  this class, which serves as the base class for component displayed in side drawers,
//        can eliminate the need for repetitive code while simplifying interactions with drawer components.
@Component({
    selector: 'app-drawer-component-base',
    templateUrl: './drawer-component-base.component.html',
    styleUrls: ['./drawer-component-base.component.scss'],
    standalone: false
})
export abstract class DrawerComponentBase {
    // Input.
    //@Input() drawerComponentLiaison: IDrawerComponentLiaison = null;

    // Constructor.
    protected constructor() {
    }

    // Abstract properties.
    public abstract get drawerComponentLiaison(): IDrawerComponentLiaison;
    public abstract set drawerComponentLiaison(value: IDrawerComponentLiaison);

    // ngOnInit() -- a derived class should call this method as the first line of its implementation of ngOnInit().
    // (The calling of this method from derived classes ngOnInit() methods is critically important as it suppies
    // a Liaison object with the drawer component which forms one side of the relationshp it manages so that it can
    // configure it with information, subscribe to its events, and so on)
    protected ngOnInit(): void {
        if (this.drawerComponentLiaison != null)
            this.drawerComponentLiaison.drawerComponentInitialized(this);
    }

    protected ngOnDestroy(): void {
        if (this.drawerComponentLiaison != null)
            this.drawerComponentLiaison.drawerComponentDestroyed(this);
    }
}
